import type { Wrestler } from './types.js';

export const ROSTER: Wrestler[] = [
  { id: 'cena', name: 'John Cena', tagline: 'The Cenation Leader', era: 'Legend', born: '23 Apr',
    height: { ft: 6, in: 1, cm: 185 }, weight: 251, power: 92, speed: 85, finisher: 99,
    accent: '#E6322B', accent2: '#0E1E3A', look: 'flex' },
  { id: 'taker', name: 'Undertaker', tagline: 'The Phenom', era: 'Legend', born: '24 Mar',
    height: { ft: 6, in: 10, cm: 208 }, weight: 309, power: 98, speed: 71, finisher: 96,
    accent: '#1B1B1B', accent2: '#6B0F0F', look: 'shroud' },
  { id: 'reigns', name: 'Roman Reigns', tagline: 'The Tribal Chief', era: 'Current', born: '25 May',
    height: { ft: 6, in: 3, cm: 191 }, weight: 265, power: 95, speed: 88, finisher: 94,
    accent: '#1F2937', accent2: '#A8853B', look: 'fist' },
  { id: 'stonecold', name: 'Stone Cold', tagline: 'Texas Rattlesnake', era: 'Legend', born: '18 Dec',
    height: { ft: 6, in: 2, cm: 188 }, weight: 252, power: 90, speed: 86, finisher: 100,
    accent: '#0E1E3A', accent2: '#E6322B', look: 'shout' },
  { id: 'rhea', name: 'Rhea Ripley', tagline: 'Mami', era: 'Current', born: '11 Oct',
    height: { ft: 5, in: 7, cm: 170 }, weight: 168, power: 88, speed: 90, finisher: 92,
    accent: '#1A0F2A', accent2: '#9B30E5', look: 'stance' },
  { id: 'rollins', name: 'Seth Rollins', tagline: 'The Visionary', era: 'Current', born: '28 May',
    height: { ft: 6, in: 1, cm: 185 }, weight: 217, power: 86, speed: 96, finisher: 91,
    accent: '#0F1F1A', accent2: '#26C281', look: 'kick' },
  { id: 'lesnar', name: 'Brock Lesnar', tagline: 'The Beast', era: 'Legend', born: '12 Jul',
    height: { ft: 6, in: 3, cm: 191 }, weight: 286, power: 100, speed: 87, finisher: 88,
    accent: '#3B1B0F', accent2: '#E6322B', look: 'flex' },
  { id: 'cody', name: 'Cody Rhodes', tagline: 'The American Nightmare', era: 'Current', born: '30 Jun',
    height: { ft: 6, in: 1, cm: 185 }, weight: 220, power: 87, speed: 91, finisher: 93,
    accent: '#0E1E3A', accent2: '#E6322B', look: 'fist' },
  { id: 'kane', name: 'Kane', tagline: 'The Big Red Machine', era: 'Legend', born: '26 Apr',
    height: { ft: 7, in: 0, cm: 213 }, weight: 323, power: 96, speed: 70, finisher: 89,
    accent: '#5B0606', accent2: '#1B1B1B', look: 'shroud' },
  { id: 'hbk', name: 'Shawn Michaels', tagline: 'Mr. WrestleMania', era: 'Legend', born: '22 Jul',
    height: { ft: 6, in: 1, cm: 185 }, weight: 225, power: 84, speed: 95, finisher: 97,
    accent: '#1A1A2E', accent2: '#E5C04A', look: 'stance' },
  { id: 'becky', name: 'Becky Lynch', tagline: 'The Man', era: 'Current', born: '30 Jan',
    height: { ft: 5, in: 6, cm: 168 }, weight: 135, power: 82, speed: 93, finisher: 95,
    accent: '#2B1308', accent2: '#F49A2A', look: 'shout' },
  { id: 'punk', name: 'CM Punk', tagline: 'Best in the World', era: 'Current', born: '26 Oct',
    height: { ft: 6, in: 2, cm: 188 }, weight: 218, power: 85, speed: 92, finisher: 98,
    accent: '#0E0E0E', accent2: '#E6322B', look: 'kick' },
];

export function findWrestler(id: string): Wrestler | undefined {
  return ROSTER.find((w) => w.id === id);
}
